import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NOTIFICATION_ERROR, NOTIFICATION_SUCCESS, NOTIFICATION_WARNING } from '../../constants/constant';
import { NotificationAlert } from '../../models/notificationAlert.model';

@Injectable({
  providedIn: 'root'
})
export class ToasterNotificationService {

  public notification = new Subject<NotificationAlert>();
  constructor() { }

  private showNotification(alert: NotificationAlert): void {
    this.notification.next(alert);
  }

  public showErrorNotification(message: string): void {
    this.showNotification({
      type: NOTIFICATION_ERROR,
      message
    });
  }

  public showSuccessNotification(message: string): void {
    this.showNotification({
      type: NOTIFICATION_SUCCESS,
      message
    });
  }

  public showWarningNotification(message: string): void {
    this.showNotification({
      type: NOTIFICATION_WARNING,
      message
    });
  }
}
